<ng-container *transloco="let t">
    <div class="modal-header">
        <h4 class="modal-title" id="e-form-branding">{{t("Template EForm - Terms and conditions modal title text (Template/Eform signing - section) - Terms and conditions")}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.close(false)">
        <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body px-50" tabindex="0" ngbAutofocus>
        <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="term_and_condition_content_scroll">
            <p [innerHTML]="termsAndCondition.term_and_condition_content" class="pre-wrap px-1 font-small-3 mb-0" id="terms_and_conditions" readonly></p>
        </ng-scrollbar>
    </div>
    <div class="modal-footer mt-1 px-0">
        <div class="col-xl-12 col-md-12 text-end col-12">
        <button type="button" class="btn btn-success" rippleEffect (click)="activeModal.close(true)">{{ t("Agreement statement (Eform terms and condition) - I agree") }}</button>
        </div>
    </div>
</ng-container>
